import React, { useEffect } from 'react';
import MensagemErro from '../MensagemErro';

const PaginaQuemSomos = ({setParqueSelecionado}) => {
    useEffect(() => {
        window.scroll(0, 0);
        setParqueSelecionado(true)
    }, [setParqueSelecionado]);
    return (
        <MensagemErro tipo="construcao" />
    );
}

export default PaginaQuemSomos;